module.exports = __webpack_public_path__ + "img/SAS_Polished Steel Buckler.ebdf4858.png";